export default __webpack_public_path__ + "static/media/Illustration.9e70d46f.png";